import VueI18n from 'vue-i18n';
import Vue from 'vue';
import en from './en.json';

Vue.use(VueI18n);
const locale = 'en';
const messages = {
  en
};
const i18n = new VueI18n({
  locale,
  messages
});

export default i18n;



// WEBPACK FOOTER //
// ./src/languages/i18n.js